import React, { useCallback } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { Button } from "components";
import { useProductInput, useProductOutput } from "stores/product";
import { useProjectUnit } from "stores/project";
import { useLanguage } from "stores/globalStore";
import { useTranslate } from "hooks";
import { Product3dViewModal } from "components/_Modals/Product3dViewModal/Product3dViewModal";
import { Unit } from "variables/enums";

export const Open3dViewButton = () => {
  const translate = useTranslate();
  const productOutput = useProductOutput();
  const productInput = useProductInput();
  const unit = useProjectUnit();
  const language = useLanguage();
  const isProductAccessory =
    !!productOutput?.product?.accessoryInfo?.accessoryId;

  const onClick = useCallback(() => {
    if (productInput?.seriesId === undefined) {
      console.error("Series ID is undefined. Cannot open 3D view.");
      return;
    }
    if (!productInput?.state) {
      console.error("Product state is undefined. Cannot open 3D view.");
      return;
    }
    if (!language) {
      console.error("Language is undefined. Cannot open 3D view.");
      return;
    }
    if (!unit) {
      console.warn(
        "Unit is undefined. Fallback value 'de_m3ph' will be used to open 3D view.",
      );
    }
    NiceModal.show(Product3dViewModal, {
      requestParams: {
        seriesId: String(productInput?.seriesId),
        state: productInput?.state,
        resultUnitsSystem: unit || Unit.de_m3ph,
        languageIso2L: language,
      },
    });
  }, [language, unit, productInput]);

  return (
    <Button
      data-testid="open-3dview-btn"
      className="w-100"
      icon="3-d-symbol-regular"
      onClick={onClick}
      color="outline-dark"
      disabled={isProductAccessory}
    >
      {translate("PRODUCT_CONFIGURATOR_TO_3D_VIEW")}
    </Button>
  );
};
